// GALILEO-4584 START
import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	// Section 1
	valueProp1Title: {
		id: 'project-template-select-v2.utils.templates.product-discovery.portfolio-management.value-prop-1-title',
		defaultMessage: 'Portfolio intake',
		description: 'Title for section that summarizes the value of this template',
	},
	valueProp1Description: {
		id: 'project-template-select-v2.utils.templates.product-discovery.portfolio-management.value-prop-1-description',
		defaultMessage:
			'Centralize project intake and prioritize based on goal alignment and business impact.',
		description: 'Description for section that explains more details about the value of template',
	},
	// Section 2
	valueProp2Title: {
		id: 'project-template-select-v2.utils.templates.product-discovery.portfolio-management.value-prop-2-title',
		defaultMessage: 'Lightweight capacity planning',
		description: 'Title for section that summarizes the value of this template',
	},
	valueProp2Description: {
		id: 'project-template-select-v2.utils.templates.product-discovery.portfolio-management.value-prop-2-description',
		defaultMessage:
			'Use high-level capacity planning to start discussions on how to allocate teams across programs.',
		description: 'Description for section that explains more details about the value of template',
	},
	// Section 3
	valueProp3Title: {
		id: 'project-template-select-v2.utils.templates.product-discovery.portfolio-management.value-prop-3-title',
		defaultMessage: 'Communicate progress',
		description: 'Title for section that summarizes the value of this template',
	},
	valueProp3Description: {
		id: 'project-template-select-v2.utils.templates.product-discovery.portfolio-management.value-prop-3-description',
		defaultMessage: "Share a single view with your portfolio's latest priorities and progress.",
		description: 'Description for section that explains more details about the value of template',
	},
	recommendedList1: {
		id: 'project-template-select-v2.utils.templates.product-discovery.portfolio-management.recommended-list-1',
		defaultMessage: 'Prioritizing projects and programs across teams.',
		description: 'Recommended project types to use this template',
	},
	recommendedList2: {
		id: 'project-template-select-v2.utils.templates.product-discovery.portfolio-management.recommended-list-2',
		defaultMessage: 'Product teams',
		description: 'Recommended project types to use this template',
	},
});

// GALILEO-4584 END
